// extracted by mini-css-extract-plugin
export default {"root":"Control_root__ahgGq","status-block":"Control_status-block__b2PY8","status-title":"Control_status-title__LEnhF","control":"Control_control__vwgOO"};